module.exports = __webpack_public_path__ + "static/img/banner-2.21c653a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-2.png
// module id = LEDK
// module chunks = 1